var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "subsection"
  }, [_c('div', {
    staticClass: "summary_label"
  }, [_vm._v("Validator")]), _c('div', [_vm._v(_vm._s(_vm.tx.validatorNodeID))])]), _c('div', {
    staticClass: "subsection"
  }, [_c('div', {
    staticClass: "summary_label"
  }, [_vm._v("Duration")]), _c('div', [_c('div', [_vm._v(_vm._s(_vm.duration) + " days (" + _vm._s(_vm.elapsed) + "% elapsed)")]), _c('StakingTimeline', {
    attrs: {
      "start-time": _vm.tx.validatorStart,
      "end-time": _vm.tx.validatorEnd,
      "current-time": _vm.currentTime
    }
  })], 1)]), _c('div', {
    staticClass: "subsection"
  }, [_vm.tx.rewarded ? _c('div', [_c('div', {
    staticClass: "summary_label"
  }, [_vm._v("Status")]), _vm.rewardedDate ? _c('div', [_vm.isValidatorTx ? [_c('p', [_vm._v(" Validator is rewarded "), _c('span', {
    staticClass: "status"
  }, [_vm._v(_vm._s(_vm._f("toAVAX")(_vm.validatorRewardUTXO.amount)) + " AVAX")])])] : _vm._e(), _vm.isDelegatorTx ? [_c('p', [_vm._v(" Delegator is rewarded "), _c('span', {
    staticClass: "status"
  }, [_vm._v(_vm._s(_vm._f("toAVAX")(_vm.delegatorRewardUTXO.amount)) + " AVAX")])]), _c('p', {
    staticClass: "margin_top"
  }, [_vm._v(" Validator is rewarded "), _c('span', {
    staticClass: "status"
  }, [_vm._v(_vm._s(_vm._f("toAVAX")(_vm.delegatorFeeUTXO.amount)) + " AVAX")]), _vm._v(" as fee ")])] : _vm._e(), _c('p', {
    staticClass: "margin_top"
  }, [_vm._v(" " + _vm._s(_vm._f("fromNow")(_vm.rewardedDate)) + " (" + _vm._s(_vm.rewardedDate.toLocaleString()) + ") ")])], 2) : _c('div', [_c('span', {
    staticClass: "status"
  }, [_vm._v("Staking")])])]) : _vm._e()])]);
}
var staticRenderFns = []

export { render, staticRenderFns }